import { defineMessages } from 'react-intl';

export default defineMessages({
  noOrders: {
    id: 'app.dashboard.no.orders',
    defaultMessage: 'Looks like there are no orders in your account just yet',
  },
  dispatchedOrder: {
    id: 'app.dashboard.order.dispatched',
    defaultMessage: 'Dispatched',
  },
  packingOrder: {
    id: 'app.dashboard.order.packing',
    defaultMessage: 'Preparing order',
  },
  packingAndPrintingOrder: {
    id: 'app.dashboard.order.packAndPrint',
    defaultMessage: 'Preparing order',
  },
  printingOrder: {
    id: 'app.dashboard.order.printing',
    defaultMessage: 'Processing',
  },
  purchasedOrder: {
    id: 'app.dashboard.order.purchased',
    defaultMessage: 'Purchased',
  },
  cancelledOrder: {
    id: 'app.dashboard.order.cancelled',
    defaultMessage: 'Cancelled',
  },
  unknownOrder: {
    id: 'app.dashboard.order.unknown',
    defaultMessage: 'Unknown',
  },
  collectionReadyOrder: {
    id: 'app.dashboard.order.readyToCollect',
    defaultMessage: 'Ready for collection',
  },
  returnedOrder: {
    id: 'app.dashboard.order.returned',
    defaultMessage: 'Returned to warehouse',
  },
  collectedOrder: {
    id: 'app.dashboard.order.collected',
    defaultMessage: 'Collected',
  },
  partDispatchedOrder: {
    id: 'app.dashboard.order.partDispatched',
    defaultMessage: 'Part dispatched',
  },
  partReadyOrder: {
    id: 'app.dashboard.order.partReady',
    defaultMessage: 'Part ready',
  },
  reprintingOrder: {
    id: 'app.dashboard.order.reprinting',
    defaultMessage: 'Reprinting',
  },
  completedOrder: {
    id: 'app.dashboard.order.completed',
    defaultMessage: 'Completed',
  },
  viewOrders: {
    id: 'app.dashboard.order.viewOrders',
    defaultMessage: 'View All',
  },
  startOrdering: {
    id: 'app.dashboard.order.startOrdering',
    defaultMessage: 'Start ordering',
  },
});
